var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:`${_vm.icon} text-${_vm.variant} cursor-pointer ${_vm.btnClass}`,attrs:{"data-bs-toggle":"tooltip","title":_vm.tooltip},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }